export default __webpack_public_path__ + "static/media/reload.c1aedb7f.svg";